export class ConsoleMetric {
  constructor({ metric_id, name }) {
    this.id = metric_id;
    this.name = name;
    this.metric_id = metric_id;
    this.metric_name = name;
  }
}

export default class Console {
  constructor({
    id,
    name,
    description,
    city,
    map_style,
    created_at,
    created_by,
    filters,
    is_active,
    magic_link,
    metrics,
  }) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.city = city;
    this.map_style = map_style;
    this.created_at = created_at;
    this.created_by = created_by;
    this.filters = filters;
    this.is_active = is_active;
    this.magic_link = magic_link;
    this.metrics = metrics.map(metric => new ConsoleMetric(metric));
  }

  /**
   * Returns list of names of all metrics in the console
   */
  getMetricNames() {
    return this.metrics.map(metric => metric.name);
  }

  /**
   * Return basic metadata of the console
   */
  getMetaData() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      city: this.city,
      map_style: this.map_style,
    };
  }

  /**
   * Returns list of all metrics
   */
  getMetrics() {
    return this.metrics;
  }

  /**
   * Returns list of all filters
   */
  getFilters() {
    return this.filters.map(filter => filter.col);
  }
}
